import { all, put, takeEvery } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { fetchWrapperFuncNoLoading } from '../../../utils';
import { getUseCaseLogApi, ServerType } from '../../System/systemConfig';
import {
    sysadminLoadUseCaseLogs,
    sysadminSetUseCaseLogs,
    SYSADMIN_CLEAR_USE_CASE_LOGS,
    SYSADMIN_LOAD_USE_CASE_LOGS
} from './actions';

function* loadUseCaseLogs(action: Action<ServerType>) {
    const serverName = action.payload;
    const api = getUseCaseLogApi(serverName);

    yield* fetchWrapperFuncNoLoading(() => api.getUseCaseLogs(), [
        r => sysadminSetUseCaseLogs({ server: serverName, useCaseLogs: r })
    ]);
}

function* clearUseCaseLogs(action: Action<ServerType>) {
    const serverName = action.payload;
    const api = getUseCaseLogApi(serverName);

    yield* fetchWrapperFuncNoLoading(() => api.clearUseCaseLogs());
    yield put(sysadminLoadUseCaseLogs(serverName));
}

function* watchForUseCaseLogActions() {
    yield takeEvery(SYSADMIN_LOAD_USE_CASE_LOGS, loadUseCaseLogs);
    yield takeEvery(SYSADMIN_CLEAR_USE_CASE_LOGS, clearUseCaseLogs);
}

export function* sagaUseCaseLogs() {
    yield all([watchForUseCaseLogActions()]);
}

